import { VCard } from 'vuetify/lib/components/VCard';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VMain } from 'vuetify/lib/components/VMain';

var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(VMain,{staticClass:"mt-16"},[_c('h1',{staticClass:"text-h4 ma-4"},[_vm._v("Drużyny")]),_c('h2',{staticClass:"text-h6 ma-4 mt-6 mb-0"},[_vm._v("Lista turniejowych drużyn")]),_c(VContainer,[_c(VCard,{attrs:{"rounded":""}},[_vm._l((Object.values(_vm.teams)),function(item,index){return [_c('list-item-team',{key:item.id,attrs:{"team":item}}),(index < Object.values(_vm.teams).length - 1)?_c(VDivider,{key:index,attrs:{"inset":""}}):_vm._e()]})],2)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }